export default __webpack_public_path__ + "static/media/assessment-car.38b77f62.svg";